import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Automatic PREVIEW / PRODUCTION label from the backend (driven by ENV_LABEL
// or the request host). Colour-coded so an admin can never confuse which
// environment they're looking at: amber = preview, red = production.
export const EnvironmentBanner = () => {
  const [label, setLabel] = useState(null);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${BACKEND_URL}/api/system/environment`)
      .then((r) => { if (alive) setLabel(r.data?.label || null); })
      .catch(() => { if (alive) setLabel(null); });
    return () => { alive = false; };
  }, []);

  if (!label) return null;
  const isProd = label === "PRODUCTION";

  return (
    <div
      data-testid="env-banner"
      className={`px-3 py-1 rounded-full text-xs font-bold tracking-widest uppercase border ${
        isProd
          ? "bg-red-500/15 text-red-300 border-red-500/40"
          : "bg-amber-500/15 text-amber-300 border-amber-500/40"
      }`}
      title={isProd
        ? "You are on the LIVE production deployment. Changes here affect real users."
        : "You are on the preview (dev) environment. Safe to test."}
    >
      {isProd ? "● PRODUCTION" : "● PREVIEW"}
    </div>
  );
};

export default EnvironmentBanner;
